import { FunctionComponent } from 'react';
import Icon, { Icons } from '../Icon/Icon';
import styles from './Badge.module.scss';

export type BadgeProps = {
  label: string;
  color?:
    | 'active'
    | 'inactive'
    | 'pending'
    | 'primary'
    | 'darkgrey'
    | 'red'
    | 'positive'
    | 'negative'
    | 'info'
    | 'neutral';
  varient?: 'regular' | 'outline' | 'outlinesmall';
  hasIcon?: boolean;
  width?: string;
};

type FC = FunctionComponent<BadgeProps>;

const Badge: FC = ({
  label = 'Badge',
  color = 'inactive',
  varient = 'regular',
  hasIcon = false,
  width,
}: BadgeProps) => (
  <div className={[styles.container, styles[color], styles[color], styles[varient]].join(' ')} style={{ width }}>
    {hasIcon && <Icon height="24px" width="24px" icon={IconMap(color)} color="none" />}
    <div>{label}</div>
  </div>
);
function IconMap(color: string): Icons | undefined {
  const map: { [key: string]: Icons } = {
    positive: 'statePositive',
    negative: 'stateNegative',
    red: 'stateNegative',
    info: 'stateInfo',
    neutral: 'stateNeutral',
  };
  return map[color];
}

export default Badge;
